<!-- Header -->
<header
  class="bg-primary p-2 md:p-3 flex align-items-center justify-content-between"
>
  <div class="w-4"></div>
  <div class="w-4 text-center">
    <img class="w-4rem md:w-6rem" src="/assets/img/ufp-logo2.svg" alt="Logo" />
  </div>
  <div class="w-4 flex justify-content-end"></div>
</header>
<!-- Header -->

<!-- Section -->
@if (errorCode() === "notenabled") {
  <div
    class="surface-0 border-round-top p-4 h-screen overflow-y-auto text-center flex justify-content-center"
  >
    <div class="w-12 md:w-7 xl:w-5 py-7">
      <h2 class="mb-0 p-error text-7xl text-center">
        <img src="assets/img/oops-text-dark.svg" alt="Oops" />
      </h2>
      <img
        class="block mx-auto my-3"
        src="assets/img/img-tenant-not-found.svg"
        alt="Tenant Not Found"
      />
      <strong class="block text-base mb-1">
        {{ companyDetails() | multilingualName }}
      </strong>
      is not currently available on the app. <br />
      Please reach out to your gym and encourage them to join this fantastic
      app.
    </div>
  </div>
}
<!-- Section -->

<!-- Section -->
@if (errorCode() === "companynotfound") {
  <div
    class="surface-0 border-round-top p-4 h-screen overflow-y-auto text-center flex justify-content-center"
  >
    <div class="w-12 md:w-7 xl:w-5 py-7">
      <h2 class="mb-0 p-error text-7xl text-center">
        <img src="assets/img/oops-text-dark.svg" alt="Oops" />
      </h2>
      <img
        class="block mx-auto my-3"
        src="assets/img/error-img.svg"
        alt="company Not Found"
      />
      <strong class="block text-base mb-1"
        >Oops! We cannot find any organization with the provided url address.
      </strong>
    </div>
  </div>
}
<!-- Section -->

<!-- Section Teant Not Found -->
@if (errorCode() === "tenantnotfound") {
  <div
    class="surface-0 border-round-top p-4 h-screen overflow-y-auto text-center flex justify-content-center"
  >
    <div class="w-12 md:w-7 xl:w-5">
      <h2 class="mb-0 p-error text-7xl text-center">
        <img src="assets/img/oops-text-dark.svg" alt="Oops" />
      </h2>
      <img
        class="block mx-auto my-3"
        src="assets/img/tenant-not-found-img.svg"
        alt="tenant Not Found"
      />
      <strong class="block text-base mb-1"
        >Oops! We cannot find any tenant with the provided tenant uuid in url.
      </strong>
    </div>
  </div>
}
<!-- Section Teant Not Found -->
